import approval from '@/api/hr/approval-request'

import { baseState, baseMutations } from '@/store/mixins'
import { camelCase, mapKeys } from 'lodash'
class ShopHistoryPagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
  shop_history_search: null,
	approve_status: 2,
	approve_shop_history_status: 2,
  shopHistoryPagination: new ShopHistoryPagination(),
  shopHistoryResources: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
	SET_APPROVE_STATUS(state, value){
		state.approve_status = value
	},
	SET_APPROVE_SHOP_HISTORY_STATUS(state, value){
		state.approve_shop_history_status = value
	},
  RECEIVE_RESOURCES_SHOP_HISTORY(state, { data, ...meta }) {
    state.shopHistoryResources = []
    data.forEach(resource => {
      state.shopHistoryResources.push(Object.assign(resource, { _deleting: false }))
    })
    state.shopHistoryPagination = new ShopHistoryPagination(mapKeys(meta, (v, k) => camelCase(k)))
  },
  SET_SHOP_HISTORY_SEARCH(state, value){
    state.shop_history_search = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
      },
      attrubutes
    )
    return approval.getApprovalList({ params })
  },
  fetchReCheckIn(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: -1,
      },
      attrubutes
    )
    return approval.getReCheckRequest({ params })
  },
  fetchReCheckInHistory(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
					app_type_id: 5,
					approve_status: context.state.approve_shop_history_status,
          search: context.state.shop_history_search
        }
      },
      attrubutes
    )
    return approval.getReCheckRequest({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES_SHOP_HISTORY', response)
      return Promise.resolve(response)
    })
  },
	historyFetch(context, attrubutes = {}){
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
					app_type_id: 1,
					approve_status: context.state.approve_status,
          search: context.state.search
        }
      },
      attrubutes
    )
    return approval.getApprovalList({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
	},
  store(context, data) {
    return approval.store(data)
  }
}
